/** /me store — current user metadata (persona, has_privacy_pin). */
import { api } from "$lib/api/client";

export type Persona = "personal" | "family" | "business";
export type Me = {
  id: string;
  email: string;
  name: string;
  persona: Persona;
  has_privacy_pin: boolean;
};

function createMeStore() {
  let me = $state<Me | null>(null);
  let loading = $state(false);

  async function load() {
    if (loading) return;
    loading = true;
    try {
      me = await api<Me>("/me");
    } catch {
      me = null;
    } finally {
      loading = false;
    }
  }

  function clear() {
    me = null;
  }

  async function setPersona(p: Persona) {
    await api("/me/persona", { method: "PUT", body: JSON.stringify({ persona: p }) });
    if (me) me = { ...me, persona: p };
  }

  async function setPin(pin: string, current_pin?: string) {
    await api("/me/privacy-pin", {
      method: "PUT",
      body: JSON.stringify({ pin, current_pin }),
    });
    if (me) me = { ...me, has_privacy_pin: true };
  }

  async function clearPin(pin: string) {
    await api("/me/privacy-pin", {
      method: "DELETE",
      body: JSON.stringify({ pin }),
    });
    if (me) me = { ...me, has_privacy_pin: false };
  }

  return {
    get me() { return me; },
    get loading() { return loading; },
    load,
    clear,
    setPersona,
    setPin,
    clearPin,
  };
}

export const meStore = createMeStore();
